// extracted by mini-css-extract-plugin
export var image = "styles-module__image___MKvYl";
export var picture = "styles-module__picture___yt6Op";
export var signup = "styles-module__signup___AszA4";
export var form = "styles-module__form___bEVQo";